define('presentation/settings/blocking/presentationObjects/blockedPhoneNumberPresentationObject',[
    'common/converters/phoneNumberFormatter',
    'common/time/datetimeFormatter'
], function () {
    const PhoneNumberFormatterConstructor = require('common/converters/phoneNumberFormatter');
    const _phoneNumberFormatter = new PhoneNumberFormatterConstructor();

    const DateTimeFormatterConstructor = require('common/time/datetimeFormatter');
    const _dateTimeFormatter = new DateTimeFormatterConstructor();


    return function () {
        const self = this;

        self.blockedPhoneNumberId = null;
        self.phoneNumber = null;
        self.createdDateTime = ko.observable("");
        self.formattedPhoneNumber = ko.pureComputed(() => {
            return _phoneNumberFormatter.toInternationalWithParens(self.phoneNumber);
        });
        self.formattedCreatedDateTime = ko.pureComputed(() => {
            return _dateTimeFormatter.humanizedDay(self.createdDateTime());
        });
    };
});

